import React from "react";
import { cn } from "@/lib/utils";

interface SectionHeaderProps {
  icon: React.ElementType;
  title: string;
  subtitle?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ icon: Icon, title, subtitle }) => (
  <div className="flex items-center gap-3 mb-4">
    <div className="h-9 w-9 rounded-md border border-gray-200 bg-gray-50 flex items-center justify-center shadow-sm">
      <Icon className="h-4 w-4 text-gray-600" />
    </div>
    <div className="leading-tight">
      <div className="text-sm font-semibold text-gray-900">{title}</div>
      {subtitle && <div className="text-xs text-gray-500">{subtitle}</div>}
    </div>
  </div>
);
